function initialiseCreatorForms() {
  document.querySelectorAll('[data-creators-form]').forEach((root) => {
    if (root.dataset.creatorFormReady === 'true') return;
    root.dataset.creatorFormReady = 'true';
    const form = root.querySelector('form');
    const note = root.querySelector('[data-creator-note]');
    const tags = root.querySelector('[data-creator-tags]');
    if (!form || !note || !tags) return;

    form.addEventListener('submit', (event) => {
      const socialLinks = [...root.querySelectorAll('[data-note-field="Instagram"], [data-note-field="TikTok"], [data-note-field="YouTube / Other"]')]
        .some((field) => field.value.trim());
      if (!socialLinks) {
        event.preventDefault();
        const first = root.querySelector('[data-note-field="Instagram"]');
        first.setCustomValidity(document.documentElement.lang.startsWith('fr') ? 'Ajoutez au moins un lien vers un réseau social.' : 'Add at least one social profile link.');
        first.reportValidity();
        return;
      }

      const values = [...root.querySelectorAll('[data-note-field]')]
        .filter((field) => field.value.trim())
        .map((field) => [field.dataset.noteField, field.value.trim()]);

      note.value = values.map(([label, value]) => `${label}: ${value}`).join('\n');

      // Shopify's storefront customer form does not persist contact[note].
      // Preserve every application field in private, structured customer tags;
      // the embedded admin app decodes these tags into a readable application.
      const applicationTags = values.flatMap(([label, value]) => {
        const encoded = encodeURIComponent(value);
        const chunks = encoded.match(/.{1,180}/g) || [''];
        return chunks.map((chunk, index) =>
          `LGCF:${encodeURIComponent(label)}:${index + 1}:${chunks.length}:${chunk}`
        );
      });
      tags.value = [
        'Le Galion Creator Application',
        document.documentElement.lang.startsWith('fr') ? 'Le Galion Locale FR' : 'Le Galion Locale EN',
        ...applicationTags,
      ].join(', ');
    });

    root.querySelectorAll('[data-note-field="Instagram"], [data-note-field="TikTok"], [data-note-field="YouTube / Other"]').forEach((field) => {
      field.addEventListener('input', () => field.setCustomValidity(''));
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseCreatorForms);
} else {
  initialiseCreatorForms();
}
